module.exports = __webpack_public_path__ + "assets/code.cbe8fc67.svg";